import React, { FunctionComponent } from 'react'
import { useUserManager } from '../../../ng-compat/hooks'
import { getFeatureFromCache } from '../../../util/feature-cache'
import { PERMISSIONS } from '../../../constants'
import { useAppSelector } from '../../../state/hooks'
import { selectCurrentSale } from '../../../state/slices/currentSale/currentSaleSlice'
import {
  isConfirmedNotReadyToComplete,
  isDismissable,
} from '../../../functions/sale'
import { MoreActionsItemName } from '../useMoreSaleActions'
import { LineItemUser } from '../../../models/line-item'
import { RetrieveSale } from './RetrieveSale/RetrieveSale'
import { ParkSale } from './ParkSale/ParkSale'
import { MoreActions } from './MoreActions'
import { DismissSale } from './DismissSale'

type Props = {
  shouldDisableActions: boolean
  retrieveParkedSale: (saleId: string) => void
  moreActionsItemHandler: (
    data: MoreActionsItemName,
    user?: LineItemUser
  ) => void
}

export const SaleActions: FunctionComponent<Props> = ({
  shouldDisableActions,
  retrieveParkedSale,
  moreActionsItemHandler,
}) => {
  const userManager = useUserManager()
  const sale = useAppSelector(selectCurrentSale)
  const isSaleDismissable = isDismissable(sale)

  const canProcessParkedSales = getFeatureFromCache(
    'enable_permission_park_sale_check'
  )
    ? userManager.hasPermission(PERMISSIONS.SALE_PARKED)
    : true

  const canParkSale =
    !isConfirmedNotReadyToComplete(sale) &&
    !sale.isSavedUnfulfilled &&
    !sale.isSavedService

  return (
    <div className="sale-actions-container">
      <div className="vd-btn-group sale-actions">
        {canProcessParkedSales ? (
          <RetrieveSale retrieveParkedSale={retrieveParkedSale} />
        ) : null}
        {canParkSale ? (
          <ParkSale shouldDisableActions={shouldDisableActions} />
        ) : null}
        {isSaleDismissable && <DismissSale disabled={shouldDisableActions} />}
        {!isSaleDismissable && (
          <MoreActions
            shouldDisableActions={shouldDisableActions}
            moreActionsItemHandler={moreActionsItemHandler}
          />
        )}
      </div>
    </div>
  )
}
